import { useState } from "react";
import useTranslation from "../../hooks/useTranslation";
import { Activity, Event } from "../../models/activity";
import { ActivityAccordion } from "../ActionPlanActivity/ActivityAccordion";
import { Typography } from "../ui/Typography/Typography";

interface SuggestedActivitiesStepProps {
  activities: Activity[];
  setActivities: (activities: Activity[]) => void;
}
export const SuggestedActivitiesStep = ({
  activities,
  setActivities,
}: SuggestedActivitiesStepProps) => {
  const { t } = useTranslation("actionPlanPage");
  const [dateChangeErrors, setDateChangeErrors] = useState<
    Record<string, string>
  >({});

  const handleDateChange = (
    clientId: string,
    eventIndex: number,
    newDate: Date
  ) => {
    const activity = activities.find((a) => a.clientId === clientId);
    if (!activity) return;

    const updatedActivity = activity.updateEventDate(eventIndex, newDate);

    if (!updatedActivity.validateEventsOrder()) {
      setDateChangeErrors((prev) => ({
        ...prev,
        [clientId]: t("timeline.errors.touchpointOrderError") as string,
      }));
    } else {
      // Remove error for this activity
      setDateChangeErrors((prev) => {
        const { [clientId]: _, ...rest } = prev;
        return rest;
      });
    }

    setActivities(
      activities.map((a) => (a.clientId === clientId ? updatedActivity : a))
    );
  };
  return (
    <div className="SuggestedActivitiesStep">
      {activities.length === 0 ? (
        <Typography desktop="body1" color="secondary">
          {t("addModules.overview.empty")}
        </Typography>
      ) : (
        activities.map((activity) => {
          const description =
            activity.extraProperties?.training_module?.description;
          const getEventDescription = (event: Event) =>
            event.extraProperties?.touchpoint?.description;
          const getEventInfo = (event: Event) =>
            event.extraProperties?.touchpoint
              ? t("journey.touchpointTooltip")
              : undefined;
          return (
            <ActivityAccordion
              key={activity.clientId}
              activity={activity}
              title={activity.label}
              description={description}
              getEventDescription={getEventDescription}
              getEventInfo={getEventInfo}
              onDateChange={handleDateChange}
              error={dateChangeErrors[activity.clientId]}
            />
          );
        })
      )}
    </div>
  );
};
